import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

type RedirectAlertProps = {
  title: string
  description: string
  actionLabel: string
  to: string
  delayMs?: number
}

export function RedirectAlert({
  title,
  description,
  actionLabel,
  to,
  delayMs = 2200,
}: RedirectAlertProps) {
  const navigate = useNavigate()
  const { workspace_slug } = useParams<{ workspace_slug?: string }>()
  const target =
    to === "home" || to === "../home"
      ? workspace_slug
        ? `/${workspace_slug}/home`
        : "/"
      : to

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      navigate(target, { replace: true })
    }, delayMs)

    return () => window.clearTimeout(timeoutId)
  }, [delayMs, navigate, target])

  return (
    <div className="flex min-h-[calc(100svh-var(--header-height))] items-center justify-center p-6">
      <AlertDialog open>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>{description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction onClick={() => navigate(target, { replace: true })}>
              {actionLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
